export class MobileHeaderScrollToggle {
  constructor({
    headerSelector = '.winefestival-header',
    mobileBreakpoint = 1024,
    delta = 8,
    hiddenClass = 'is-hidden-on-scroll',
  } = {}) {
    this.header = document.querySelector(headerSelector);
    this.mobileBreakpoint = mobileBreakpoint;
    this.delta = delta;
    this.hiddenClass = hiddenClass;
    this.lastScrollY = window.scrollY || 0;
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  init() {
    if (!this.header) return;
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    this.onResize();
  }

  destroy() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    this.header?.classList.remove(this.hiddenClass);
  }

  isMobile() {
    return window.innerWidth <= this.mobileBreakpoint;
  }

  isMenuOpen() {
    const navWrapper = this.header?.querySelector('.nav-wrapper');
    const burger = this.header?.querySelector('.burger-btn');
    return Boolean(
      navWrapper?.classList.contains('active') || burger?.classList.contains('active')
    );
  }

  onResize() {
    if (!this.isMobile()) {
      this.header.classList.remove(this.hiddenClass);
      this.lastScrollY = window.scrollY || 0;
    }
  }

  onScroll() {
    if (!this.header || !this.isMobile()) return;

    const currentY = window.scrollY || 0;
    const diff = currentY - this.lastScrollY;

    if (Math.abs(diff) < this.delta) return;
    if (this.isMenuOpen()) {
      this.header.classList.remove(this.hiddenClass);
      this.lastScrollY = currentY;
      return;
    }

    if (currentY <= 0 || diff < 0) {
      this.header.classList.remove(this.hiddenClass);
    } else {
      this.header.classList.add(this.hiddenClass);
    }

    this.lastScrollY = currentY;
  }
}

export function initMobileHeaderScrollToggle() {
  const toggle = new MobileHeaderScrollToggle();
  toggle.init();
  return () => toggle.destroy();
}
